import React from "react";
import { Link } from "react-router-dom";
import DeleteWindow from "./DeleteWindow";
import { Navigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrashCan,
  faArrowPointer,
  faRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";

// child of the Home component

export default function Profile(props) {
  const [deleteWarning, setDeleteWarning] = React.useState(false);
  const [itemToBeDeleted, setItemToBeDeleted] = React.useState(null);
  const [redirect, setRedirect] = React.useState(false);
  const [userPosts, setUserPosts] = React.useState(null);
  const [userLists, setUserLists] = React.useState(null);
  const [contentType, setContentType] = React.useState(true); // true: posts, false: lists
  let userPostsOverview = null;
  let userListsOverview = null;

  // fetching all posts from database with this user
  React.useEffect(() => {
    async function fetchData() {
      const res = await fetch(`${process.env.REACT_APP_SERVER_URL}/profile`, {
        credentials: "include",
      });
      const data = await res.json();
      if (!res.ok) {
        alert(data.error);
        return;
      }
      setUserPosts(data.posts);
      setUserLists(data.lists);
    }
    fetchData();
  }, []);
  

  // prompts the delete warning window
  function toggleDeleteWarning(item, type) {
    //console.log("Item to be deleted:", item);
    setItemToBeDeleted({item, type});
    setDeleteWarning((prev) => !prev);
  }

  // loading page while waiting for the data to fetch
  if (!userPosts) {
    return <h1 className="loading">Loading</h1>;
  }

  // displaying all post titles
  if (userPosts) {
    userPostsOverview = userPosts.map((post, key) => (
      <section className="post-title-card">
        <p>{post.title}</p>
        <div className="options">
          <Link to={`/post/${post._id}`}>
            <button>
              <FontAwesomeIcon icon={faArrowPointer}></FontAwesomeIcon>
            </button>
          </Link>
          <button onClick={() => toggleDeleteWarning(post, "post")}>
            <FontAwesomeIcon icon={faTrashCan}></FontAwesomeIcon>
          </button>
        </div>
      </section>
    ));
  }
  if (userLists) {
    userListsOverview = userLists.map((list, key) => (
      <section className="post-title-card">
        <p>{list.name}</p>
        <div className="options">
          <Link to={`/list/${list._id}`}>
            <button>
              <FontAwesomeIcon icon={faArrowPointer}></FontAwesomeIcon>
            </button>
          </Link>
          <button onClick={() => toggleDeleteWarning(list, "list")}>
            <FontAwesomeIcon icon={faTrashCan}></FontAwesomeIcon>
          </button>
        </div>
      </section>
    ));
  }

  // logout onclick
  async function logout() {
    const res = await fetch(`${process.env.REACT_APP_SERVER_URL}/logout`, {
      method: "POST",
      credentials: "include",
    });
    const data = await res.json();
    if (res.ok) alert(data.message);
    props.setUsername(null);
    setRedirect(true);
  }

  if (redirect) {
    return <Navigate to={"/"} />;
  } else
    return (
      <>
        {deleteWarning && (
          <DeleteWindow
            itemToBeDeleted={itemToBeDeleted}
            setDeleteWarning={setDeleteWarning}
          />
        )}
        <main className="profile-section">
          <h1>
            {props.username ? `${props.username}'s Profile` : `My Profile`}
          </h1>
          <div className="content-selection-wrapper">
            <button onClick={()=>setContentType(true)}>Posts</button>
            <button onClick={()=>setContentType(false)}>Lists</button>
          </div>
          <div className="posts-overview">
            {contentType? (userPosts ? (
              <>
                <section className="title-section">
                  <h2>Your Blog Posts</h2>
                </section>{" "}
                {userPostsOverview}
              </>
            ) : (
              <h2>You haven't posted anything yet.</h2>
            )) : (userLists ? (
              <>
                <section className="title-section">
                  <h2>Your Lists</h2>
                </section>{" "}
                {userListsOverview}
              </>
            ) : (
              <h2>You haven't made any lists yet.</h2>
            )) }
            
          </div>
          <button className="log-out-button" onClick={logout}>
            Log out{" "}
            <FontAwesomeIcon icon={faRightFromBracket}></FontAwesomeIcon>
          </button>
        </main>
      </>
    );
}
